module.exports = __webpack_public_path__ + "static/media/037-delivery.816ee8d1.svg";